import { useState } from 'react'

import { Alert, Button, Modal, TextField } from '../../components/common'
import { checkRut, formatRut, NO_RUT } from '../../lib/rut'
import { trackEvent } from '../../lib/config'
import { useImpression } from '../../lib/useImpression'

/** The sentinel `find_or_create` reads as "this patient has no RUT". */

export function NewPatientModal({
  open,
  patientsCount,
  onClose,
  onSubmit,
}: {
  open: boolean
  patientsCount: number
  onClose: () => void
  onSubmit: (rut: string) => Promise<void>
}) {
  const [rut, setRut] = useState('')
  const [hintDismissed, setHintDismissed] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const showHint = open && patientsCount === 0 && !hintDismissed

  useImpression('Onboarding Hint Shown', showHint ? { hint: 'first_patient_rut' } : null)

  const submitRut = async (value: string) => {
    if (submitting) {
      return
    }
    setSubmitting(true)
    try {
      await onSubmit(value)
    } finally {
      setSubmitting(false)
    }
  }

  const submit = () => {
    if (rut.length > 0 && !checkRut(rut)) {
      alert('Rut incorrecto')
      return
    }
    void submitRut(rut.length > 0 ? formatRut(rut) : NO_RUT)
  }

  const dismissHint = () => {
    trackEvent('Onboarding Hint Dismissed', { hint: 'first_patient_rut' })
    setHintDismissed(true)
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      id="modal"
      title="Ingresar Nuevo Paciente"
      footer={
        <Button id="btn_find_or_create" variant="simple" type="submit" disabled={submitting} onClick={submit}>
          Crear
        </Button>
      }
    >
      {showHint && (
        <Alert kind="info" onDismiss={dismissHint}>
          Ingresa el RUT del paciente y luego haz click en "CREAR"
        </Alert>
      )}
      <TextField
        id="search_or_create"
        label="Rut del paciente"
        value={rut}
        autoFocus
        onChange={setRut}
        onBlur={() => {
          if (rut.length > 0 && checkRut(rut)) {
            setRut(formatRut(rut))
          }
        }}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            submit()
          }
        }}
      />
      <a
        id="create-without-rut"
        href="#"
        onClick={(event) => {
          event.preventDefault()
          void submitRut(NO_RUT)
        }}
      >
        (Crear paciente sin rut)
      </a>
    </Modal>
  )
}
